export interface WalletLoginSession {
    address?: string;
    chainId?: number;
}

export const canReuseWalletLogin = (saved: WalletLoginSession | undefined, current: WalletLoginSession): boolean => {
    if (!saved?.address || !current.address || saved.chainId === undefined || current.chainId === undefined) {
        return false;
    }

    return saved.address.toLowerCase() === current.address.toLowerCase() && saved.chainId === current.chainId;
};

export const isSameWalletSession = (left: WalletLoginSession | undefined, right: WalletLoginSession | undefined): boolean => {
    if (!left?.address || !right?.address || left.chainId === undefined || right.chainId === undefined) {
        return false;
    }

    return left.address.toLowerCase() === right.address.toLowerCase() && left.chainId === right.chainId;
};

export const createWalletSessionKey = (session: WalletLoginSession): string => {
    if (!session.address || session.chainId === undefined) return '';
    return `${session.address.toLowerCase()}:${session.chainId}`;
};
